<template>
  <div class="bry-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="bry-container">
      <!-- Header Section -->
      <div class="bry-header">
        <div class="header-content">
          <h1 class="page-title">
            <i class="fas fa-signature title-icon"></i>
            Assinatura digital
          </h1>
        </div>
      </div>

      <!-- Content Section -->
      <div class="bry-content">
        <div class="sign-cloud-wrapper">
          <BRyHUBSignCloud />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import BRyHUBSignCloud from "../templates/BRy/HUB/sign/Cloud";

export default {
  name: "BRy",
  components: {
    NavBar,
    AuthBySessionExpired,
    BRyHUBSignCloud,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.bry-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.bry-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.bry-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

/* Content Section */
.bry-content {
  margin-bottom: 32px;
}

.sign-cloud-wrapper {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  min-height: 400px;
  padding: 24px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .bry-container {
    padding: 0 16px;
  }

  .bry-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .sign-cloud-wrapper {
    padding: 16px;
    border-radius: 12px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .title-icon {
    font-size: 20px;
  }

  .sign-cloud-wrapper {
    padding: 12px;
  }
}

/* Loading and Empty States */
.sign-cloud-wrapper:empty::before {
  content: "";
  display: block;
  width: 100%;
  height: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 2s infinite;
  border-radius: 8px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Focus and Accessibility */
.sign-cloud-wrapper:focus-within {
  box-shadow: 0 4px 20px rgba(15, 101, 176, 0.2);
  border-color: #0f65b0;
}

/* Print Styles */
@media print {
  .bry-modern {
    background: white;
  }

  .bry-header {
    box-shadow: none;
    border-bottom: 2px solid #e5e7eb;
  }

  .sign-cloud-wrapper {
    box-shadow: none;
    border: 1px solid #e5e7eb;
  }
}
</style>